import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
@Component({
  selector: 'jsg-lawyer-info-view',
  templateUrl: './lawyer-info-view.component.html',
  styleUrls: ['./lawyer-info-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LawyerInfoViewComponent implements OnInit {
  @Input() lawFirmName: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() email: string;

  constructor() {}

  ngOnInit(): void {}
}
